export const ACCEPTED_FILE_TYPES_AUDIO_USERS =
  '.mp3, .m4a, .aifc, .aiff, .ogg, .wav, .flac';
export const ACCEPTED_FILE_TYPES_VIDEO_USERS =
  '.mp3, .m4a, .aifc, .aiff, .ogg, .wav, .flac, .mp4, .mov';
export const DROPZONE_COPY_AUDIO_USERS = 'Supports mp3, m4a, wav, aif';
export const DROPZONE_COPY_VIDEO_USERS =
  'Supports mp3, m4a, wav, aif, mp4, mov';
